module.exports = __webpack_public_path__ + "static/joy-on-demand-12f0dd9ae87f193952a5b6bb016ddc24.jpg";